import { AppearanceTypes, Base, BaseProps } from 'components/Shared/Layout/base';
import styles from './styles.scss';
import cn from 'classnames';
import { flattenAppearance } from 'components/Shared/Layout/flattenAppearance';

export interface SectionProps extends BaseProps<AppearanceTypes> {
  title?: string;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type OverrideStyleInterface = any;
const _styles: OverrideStyleInterface = styles;
export const Section = ({
  className,
  children,
  title,
  lessPadding,
  padding = 'normal',
  appearance = 'primary',
  contentClassName,
  ...base
}: SectionProps) => (
  <Base
    {...base}
    flattenedAppearance={
      flattenAppearance({
        appearance,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        styles: _styles
      }) 
    }
    className={cn(
      styles.section,
      {
        [styles.lessPadding]: lessPadding || padding === 'less',
        [styles.normalPadding]: padding === 'normal'
      },
      className
    )}
  >
    {title && <h3>{title}</h3>}
    {children}
  </Base>
);
